module.exports = __webpack_public_path__ + "static/media/commverge_icon.c6a9fc3c.png";